import { VisuallyHidden } from '@reach/visually-hidden'
import { useEffect } from 'react'
import Form from 'react-bootstrap/Form'
import Group from 'react-bootstrap/FormGroup'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'

import Errors from '@/components/FormElements/Errors'
import Label from '@/components/FormElements/Label'
import Text from '@/components/FormElements/Text'
import { applyPromoCode } from '@/reducers/cart/asyncActions'
import { fieldTools } from '@/utils/fieldTools'

import SubmitButton from './SubmitButton'

const PROMO_CODE_FORM_ID = 'promo_code'
const PROMO_CODE_FIELD = 'promo_code[promo_code]'

const Field = () => {
  const dispatch = useDispatch()
  const promoCodeError = useSelector(state => state.cart.promoCode.error)

  const {
    formState: { errors },
    getValues,
    handleSubmit,
    register,
    setError
  } = useForm({
    mode: 'all'
  })

  const fieldHelper = fieldTools({
    errors,
    form: PROMO_CODE_FORM_ID,
    register,
    values: getValues()
  })

  const onSubmit = e => {
    dispatch(applyPromoCode({ value: e.promo_code.promo_code }))
  }

  const field = fieldHelper(PROMO_CODE_FORM_ID, { isRequired: false })

  useEffect(() => {
    if (promoCodeError) {
      setError(PROMO_CODE_FIELD,
        {
          message: promoCodeError,
          type: 'server'
        }
      )
      document.getElementById(PROMO_CODE_FIELD).focus()
    }
  }, [promoCodeError])

  return (
    <Form
      id={PROMO_CODE_FORM_ID}
      noValidate
      onSubmit={handleSubmit(onSubmit)}
    >
      <Form.Row>
        <Group>
          <VisuallyHidden><Label field={field} /></VisuallyHidden>
          <div className='d-flex'>
            <div className='u-full-width'>
              <Text field={field} />
              <Errors
                errorOverride={promoCodeError}
                field={field}
                hasValidation
              />
            </div>
            <SubmitButton />
          </div>
        </Group>
      </Form.Row>
    </Form>
  )
}

export default Field
